import React, { useEffect, useRef } from 'react'
import { string, oneOf, object, bool } from 'prop-types'
import Icon from './icon/icon'

export const ALERT_TYPES = {
  SUCCESS: 'success',
  ERROR: 'error',
  QUICK_TIME: 'quickTime',
  AVERAGE_TIME: 'averageTime',
  SLOW_TIME: 'slowTime',
  INFO: 'information'
}

const iconTypes = {
  [ALERT_TYPES.SUCCESS]: 'checkCircle',
  [ALERT_TYPES.ERROR]: 'crossCircle',
  [ALERT_TYPES.QUICK_TIME]: 'clock',
  [ALERT_TYPES.AVERAGE_TIME]: 'clock',
  [ALERT_TYPES.SLOW_TIME]: 'clock'
}

const AlertMessage = ({
  type = ALERT_TYPES.ERROR,
  title,
  message,
  customSvg = '',
  highLightMessage = null,
  shouldScroll = true,
  rest = {}
}) => {
  const alertEl = useRef(null)
  useEffect(() => {
    shouldScroll && alertEl.current.scrollIntoView({ behavior: 'smooth', block: 'center' })
  }, [])
  const hasStyle = Object.keys(rest).length && rest.hasOwnProperty('style') ? rest['style'] : {}
  return (<div ref={alertEl} className={`nft-alert nft-alert--${type}`} {...rest} style={hasStyle}>
    <Icon svg={iconTypes[type] || customSvg} />
    <div className='nft-alert__content'>
      { title && <h3 className='nft-alert__title'>{title}</h3> }
      <p className='nft-alert__message'>{message} {<span className={`nft-alert--highlight-${type}`}> { highLightMessage} </span>}</p>
    </div>
  </div>)
}

AlertMessage.propTypes = {
  message: string.isRequired,
  type: oneOf(Object.values(ALERT_TYPES)),
  title: string,
  customSvg: string,
  highLightMessage: string,
  shouldScroll: bool,
  rest: object
}

export default AlertMessage
